module.exports = __webpack_public_path__ + "static/media/sopt9ru.a7572237.pdf";